export class Keyword {
  public uid: number;
  public uid_site: number;
  public label: string;
  public devices: string;
  public poi: string;
  public driver: string;
  public maintenance: string;
  public devicesList: Array<number>;
  public poiList: Array<number>;
  public driversList: Array<number>;
  public maintenancesList: Array<number>;

  public constructor(
    uid?: number,
    uid_site?: number,
    label?: string,
    devices?: string,
    poi?: string,
    driver?: string,
    maintenance?: string,
    devicesList?: Array<number>,
    poiList?: Array<number>,
    driversList?: Array<number>,
    maintenancesList?: Array<number>
  ) {
    this.uid = uid;
    this.uid_site = uid_site;
    this.label = label;
    this.devices = devices;
    this.poi = poi;
    this.driver = driver;
    this.maintenance = maintenance;
    this.devicesList = devicesList;
    this.poiList = poiList;
    this.driversList = driversList;
    this.maintenancesList = maintenancesList;
  }
}
